import Dashboard from 'src/wrapper/dashboard/leader';
import Account from 'src/wrapper/account';
import TeacherList from 'src/wrapper/leaders/teacher-list';
import TeacherDetail from 'src/wrapper/leaders/teacher-detail';
import FuelList from 'src/wrapper/leaders/fuel-list';
import FuelDetail from 'src/wrapper/leaders/fuel-detail';
import TmsList from 'src/wrapper/leaders/tms-list';
import TmsDetail from 'src/wrapper/leaders/tms-detail';
import RepairList from 'src/wrapper/leaders/repair-list';
import RepairDetail from 'src/wrapper/leaders/repair-detail';
import RepairRequests from 'src/wrapper/leaders/repair-requests';
import WorkSchedule from 'src/wrapper/leaders/work-schedule';
import CarList from 'src/wrapper/leaders/car-list';
import CarDetail from 'src/wrapper/leaders/car-detail';
import CarRepair from 'src/wrapper/leaders/car-repair';
import CarPapers from 'src/wrapper/leaders/car-pagers';
import AssetFolders from 'src/wrapper/assets/folders';

export const leaderRoutes = (paths) => {
  return [
    { path: paths.dashboard.index, component: Dashboard },
    { path: paths.dashboard.account, component: Account },
    { path: paths.teachers.index, component: TeacherList },
    { path: paths.teachers.details, component: TeacherDetail },
    { path: paths.fuels.index, component: FuelList },
    { path: paths.fuels.details, component: FuelDetail },
    { path: paths.tms.index, component: TmsList },
    { path: paths.tms.details, component: TmsDetail },
    { path: paths.repairs.index, component: RepairList },
    { path: paths.repairs.details, component: RepairDetail },
    { path: paths.repairs.requests, component: RepairRequests },
    { path: paths.schedules.work.index, component: WorkSchedule },
    { path: paths.cars.index, component: CarList },
    { path: paths.cars.details, component: CarDetail },
    { path: paths.cars.repair, component: CarRepair },
    { path: paths.cars.pagers, component: CarPapers },
    { path: paths.assets.index, component: AssetFolders },
  ];
};
